import { format } from 'date-fns'
import React from 'react'
import { NavLink } from 'react-router-dom'
import { fr } from 'date-fns/locale'
import Image from './Image'



const ActuCard = ({image, title, description, link, date, category}) => {
    return (
        <>
            <div className='border border-1 border-secondary border-opacity-75 actu-card'>
                <div className='position-relative'>
                    <Image alt={title} src={image} className={'object-fit-cover actu-img'} />
                    <div className='position-absolute bottom-0 start-0 px-2 py-0 ms-1 mb-1 bgcolor-secondary text-truncate-1 fs-8s'>{category}</div>
                </div>
                <div className='p-2'>
                    <h4 className='fs-6 fw-bold text-truncate-2'>{title}</h4>
                    <p className='fs-8s text-truncate-3'>{description}</p>
                    <div className=' d-flex flex-wrap justify-content-between align-items-center'>
                        <NavLink to={link} className='d-flex justify-content-center align-items-center px-2 py-1 text-white bgcolor-primary'>
                            <i className='fa fa-book-open fs-7s text-white'></i>
                            <span className='fs-8s ms-2 text-white text-nowrap'>Lire plus</span>
                        </NavLink>
                        <span className=' fw-medium fs-6s'>Le {format(date, "dd MMM yyyy", {locale: fr})}</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ActuCard